<!--

 -->

<template>
  <teleport to="#app">
    <oxd-dialog
      v-if="show"
      class="gsl-hrm-dialog-popup"
      @update:show="onCancel"
    >
      <div class="gsl-hrm-modal-header">
        <oxd-text type="card-title">
          {{ $t('performance.confirm_review_submission') }}
        </oxd-text>
      </div>
      <div class="gsl-hrm-text-center-align">
        <oxd-text type="subtitle-2">
          {{ $t('performance.confirm_review_submission_message') }}
        </oxd-text>
      </div>
      <div class="gsl-hrm-modal-footer">
        <oxd-button
          display-type="ghost"
          class="gsl-hrm-button-margin"
          :label="$t('general.cancel')"
          @click="onCancel"
        />
        <oxd-button
          display-type="secondary"
          class="gsl-hrm-button-margin"
          :label="$t('general.ok')"
          @click="onConfirm"
        />
      </div>
    </oxd-dialog>
  </teleport>
</template>

<script>
import {OxdDialog} from '@ohrm/oxd';

export default {
  name: 'ReviewConfirmModal',
  components: {
    'oxd-dialog': OxdDialog,
  },
  data() {
    return {
      show: false,
      reject: null,
      resolve: null,
    };
  },
  methods: {
    showDialog() {
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.show = true;
      });
    },
    onConfirm() {
      this.show = false;
      this.resolve && this.resolve('ok');
    },
    onCancel() {
      this.show = false;
      this.resolve && this.resolve('cancel');
    },
  },
};
</script>

<style scoped>
.gsl-hrm-modal-header {
  margin-bottom: 1.2rem;
  display: flex;
  justify-content: center;
}
.gsl-hrm-modal-footer {
  margin-top: 1.2rem;
  display: flex;
  justify-content: center;
}
.gsl-hrm-button-margin {
  margin: 0.25rem;
}
.gsl-hrm-text-center-align {
  text-align: center;
}
</style>
